import { Box, type BoxProps } from '@mui/material'
import type { WithoutSystemProps } from 'types'
import $ from './DividersBlock.styled'

export const DividersBlock: Settle.FC<WithoutSystemProps<BoxProps>> = ({ children, sx, ...props }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      ...sx,
    }}
    {...props}
  >
    <$.Separator side="left" />
    {children}
    <$.Separator side="right" />
  </Box>
)
